import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useProfile } from '../../contexts/ProfileContext';
import ProfileSettings from '../../components/profile/ProfileSettings';
import ProfileForm from '../../components/profile/ProfileForm';
import Header from '../../components/header/Header';
import Navbar from '../../components/navigation/Navbar';
import { routesForProfile } from '../../utils/constants/autocount.routes';
import { putUserSelfInfo, putUserPreferences } from '../../services/userSelfInfo.api';
import ProfileAvatar from '../../components/profile/ProfileAvatar';
import timezones from 'timezones-list';

const Profile = (props) => {
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState('');
  // PDF and user settings state
  const [orientation, setOrientation] = useState('portrait');
  const [scaling, setScaling] = useState('automatic');
  const [pageSize, setPageSize] = useState('letter');
  let detectedTimezone = 'UTC';
  try {
    detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    detectedTimezone = 'UTC';
  }
  const [timezone, setTimezone] = useState(detectedTimezone);
  const timezoneOptions = timezones.map(tz => ({ code: tz.tzCode, label: tz.label }));

    const { userInfo, loading } = useProfile();
    const [user, setUser] = useState(userInfo || { firstName: '', lastName: '', email: '' });

    useEffect(() => {
      if (userInfo) {
        setUser(userInfo);
        if (userInfo.preferences) {
          setOrientation(userInfo.preferences.pdfOrientation || orientation);
          setScaling(userInfo.preferences.pdfScaling || scaling);
          setPageSize(userInfo.preferences.pdfPagesize || pageSize);
          setTimezone(userInfo.preferences.timezone || timezone);
        }
      }
    }, [userInfo]);
  useEffect(() => {
    if (user && user.preferences) {
      setOrientation(user.preferences.pdfOrientation || orientation);
      setScaling(user.preferences.pdfScaling || scaling);
      setPageSize(user.preferences.pdfPagesize || pageSize);
      setTimezone(user.preferences.timezone || timezone);
    }
  // Only run when user changes
  }, [user]);



  // Save handler for ProfileForm
  const handleProfileSave = ({ firstName, lastName }) => {
    putUserSelfInfo({ ...user, firstName, lastName })
        .then(() => {
          setUser(prev => ({ ...prev, firstName, lastName }));
        setSuccessMessage('User profile updated successfully');
        setTimeout(() => setSuccessMessage(''), 3000);
        setTimeout(()=> window.location.reload(), 1500);
      })
      .catch((error) => {
        console.error(`Error updating user self info: ${error}`);
      });
  };

  const handlePreferencesSave = () => {
    putUserPreferences({ pdfOrientation: orientation, pdfScaling: scaling, pdfPagesize: pageSize, timezone })
      .then(() => {
        setSuccessMessage('User preferences updated successfully');
        setTimeout(() => setSuccessMessage(''), 3000);
        setTimeout(()=> window.location.reload(), 1500);
      })
      .catch((error) => {
        console.error(`Error updating user preferences: ${error}`);
      });
  };

  const handleBackToNotifications = () => {
    history.push('/autocount/home/notifications');
  };

  return (
    <>
      <Header />
      <Navbar routes={routesForProfile} {...props} />
      {successMessage && (
        <div style={{
          position: 'fixed',
          top: 80,
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#4caf50',
          color: '#fff',
          padding: '12px 32px',
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 9999,
          fontWeight: 500,
          fontSize: 16
        }}>
          {successMessage}
        </div>
      )}
      <div style={{ width: '100%', maxWidth: 1200, margin: '20px auto 0 auto', padding: '0 20px' }}>
        <Button
          variant="outlined"
          startIcon={<ChevronLeftIcon />}
          onClick={handleBackToNotifications}
          sx={{
            marginBottom: '20px',
            color: '#1976d2',
            borderColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1976d2',
              color: '#fff',
              borderColor: '#1976d2'
            }
          }}
        >
          Back to Accelerate
        </Button>
      </div>
      <div style={{ display: 'flex', height: '80%', minHeight: 500, width: '100%', maxWidth: 1200, margin: '0 auto', gap: 40 }}>
        <div style={{ flex: '0 0 30%', height: 'calc(80vh - 50px)', padding: 24, border: '1px solid #eee', borderRadius: 8, textAlign: 'center', position: 'relative', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
          <ProfileAvatar user={user} />
          <ProfileForm user={user} onSave={handleProfileSave} />
        </div>
        <ProfileSettings
          orientation={orientation}
          setOrientation={setOrientation}
          scaling={scaling}
          setScaling={setScaling}
          pageSize={pageSize}
          setPageSize={setPageSize}
          timezone={timezone}
          setTimezone={setTimezone}
          timezoneOptions={timezoneOptions}
          onSave={handlePreferencesSave}
          preferencesUnset={
            !user?.preferences ||
            [user.preferences.pdfOrientation, user.preferences.pdfScaling, user.preferences.pdfPagesize, user.preferences.timezone].every(v => !v)
          }
        />
      </div>
    </>
  );
};

export default Profile;